import ChooseYourAgent from '@components/pages/choose-your-agent';

export default ChooseYourAgent;
